module.exports = __webpack_public_path__ + "img/t1-12.da7af24e.png";